<div class="title">{{ nameKey | translate }}</div>
<div class="description" [innerHtml]="descriptionKey | translate"></div>

@if (automationContext === context.AUTOMATION_CONTEXT_PARTNER) {
  <glxy-form-field>
    <glxy-label>
      {{ 'AUTOMATIONS.EDITOR.TRIGGERS.MANUAL_ACCOUNT_TRIGGER.WHO_CAN_RUN' | translate }}
    </glxy-label>
    <mat-select [(value)]="selectedOption">
      <mat-option *ngFor="let option of options" [value]="option.value">
        {{ option.label | translate }}
      </mat-option>
    </mat-select>
  </glxy-form-field>

  <automata-automation-replacement-chips
    *ngIf="selectedOption === specificUsers"
    label="AUTOMATIONS.EDITOR.TRIGGERS.MANUAL_ACCOUNT_TRIGGER.SPECIFIC_USERS_DESCRIPTION"
    [dataService]="userSelectorService"
    [formControl]="usersFormControl"
    [isRequired]="false"
    [supportDataPassing]="false"
  ></automata-automation-replacement-chips>
} @else {
  <div>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.MANUAL_ACCOUNT_TRIGGER.SMB_INSTRUCTIONS' | translate }}</div>
}
